import { supabase } from '@/integrations/supabase/client';
import { ApiResult, ok, err, ApiError } from '../errors';

// ============ Types ============

export interface Group {
  id: string;
  name: string;
  slug: string;
  city?: string | null;
  state?: string | null;
  country?: string | null;
  contact_name?: string | null;
  contact_email?: string | null;
  contact_phone?: string | null;
  website?: string | null;
  logo_url?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
}

// ============ Queries ============

export async function getGroups(): Promise<ApiResult<Group[]>> {
  const { data, error } = await supabase
    .from('groups')
    .select('*')
    .order('name');

  if (error) {
    return err(ApiError.fromSupabaseError(error));
  }

  return ok(data || []);
}

export async function getGroupById(id: string): Promise<ApiResult<Group | null>> {
  const { data, error } = await supabase
    .from('groups')
    .select('*')
    .eq('id', id)
    .maybeSingle();

  if (error) {
    return err(ApiError.fromSupabaseError(error));
  }

  return ok(data);
}

// ============ Queries for Program Activity Counts ============

export async function getProgramActivityCounts(
  programIds: string[]
): Promise<ApiResult<Record<string, number>>> {
  const { data: phases, error } = await supabase
    .from('program_phases')
    .select('id, program_id, phase_activities(id)')
    .in('program_id', programIds);

  if (error) {
    return err(ApiError.fromSupabaseError(error));
  }

  const countMap: Record<string, number> = {};
  phases?.forEach(phase => {
    const programId = phase.program_id;
    const activityCount = phase.phase_activities?.length || 0;
    countMap[programId] = (countMap[programId] || 0) + activityCount;
  });

  return ok(countMap);
}
